import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NoDataGraph } from '@/features/batteryOverview/utils/BatteryDataUtils';

export type KpiUnit = '%' | 'km' | 'kWh';

type BatteryHistoryGraphTooltipKpiProps = {
    i18nId: string;
    value: number | undefined;
    unit?: KpiUnit;
    /** Custom formatter function. When provided, takes precedence over unit formatting */
    formatter?: (value: number) => string;
    additionalContent?: React.ReactNode;
};

export const BatteryHistoryGraphTooltipKpi = ({
    i18nId,
    value,
    unit = undefined,
    formatter,
    additionalContent,
}: BatteryHistoryGraphTooltipKpiProps) => {
    const displayKpiValueWithUnit = () => value + (unit === '%' ? unit : ` ${unit}`);

    return (
        <div className={'display-flex'}>
            <FormattedMessage id={i18nId} />:
            {value === undefined ? (
                <NoDataGraph />
            ) : (
                <>
                    <span className="text-medium padding-left-10">
                        {formatter ? formatter(value) : displayKpiValueWithUnit()}
                    </span>
                    &nbsp;
                    {additionalContent}
                </>
            )}
        </div>
    );
};
